import React, { useCallback, useEffect, useState, Fragment } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import Layout from "../layouts";
import axios, { apiBaseUrl } from "../services/http";
import { Modal, Tooltip } from "flowbite-react";
import { Dialog, Transition, Switch } from "@headlessui/react";
import { useAccountStore } from '../store';
import Settings from '../components/Settings';

export default function MyBookings() {
  const {me, fetch: fetchUser} = useAccountStore();
  const [tab, setTab] = useState(0);
  const [showCancel, setShowCancel] = useState(false);
  const [showViewGroupMembers, setShowViewGroupMembers] = useState(false);
  const [bookings, setBookings] = useState({
    status: "idle",
    data: null,
    error: null,
  });
  const [cancel, setCancel] = useState({
    status: "idle",
    data: null,
    error: null,
  });
  const [withdraw, setWithdraw] = useState({
    status: "idle",
    data: null,
    error: null,
  });
  const [selectedBooking, setSelectedBooking] = useState(null);

  const fetchBookings = useCallback(async () => {
    setBookings((state) => ({ ...state, status: "pending", error: null }));
    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/mybookings?type=${tab === 0 ? "active" : "past"}`
      );
      setBookings((state) => ({
        ...state,
        status: "succeeded",
        data: response.data,
      }));
    } catch (error) {
      setBookings((state) => ({
        ...state,
        status: "failed",
        error: error.response.data,
      }));
    }
  }, [tab]);

  useEffect(() => {
    tab <= 1 && fetchBookings();
  }, [tab, fetchBookings]);

  const onCancel = (booking) => {
    setSelectedBooking(booking);
    setShowCancel(true);
  };

  const onConfirmCancel = async () => {
    setCancel((state) => ({ ...state, status: "pending", error: null }));
    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/mybookings/${selectedBooking.id}`
      );
      setCancel((state) => ({
        ...state,
        status: "succeeded",
        data: response.data,
      }));
      setShowCancel(false);
      setSelectedBooking(null);
      fetchBookings();
      fetchUser();
    } catch (error) {
      setCancel((state) => ({
        ...state,
        status: "failed",
        error: error.response.data,
      }));
    }
  };

  const onViewGroupMembers = (booking) => {
    setSelectedBooking(booking);
    setShowViewGroupMembers(true);
  };

  const onConfirmWithdraw = async () => {
    setWithdraw((state) => ({ ...state, status: "pending", error: null }));
    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/mybookings/${selectedBooking.id}`
      );
      setWithdraw((state) => ({
        ...state,
        status: "succeeded",
        data: response.data,
      }));
      setShowViewGroupMembers(false);
      setSelectedBooking(null);
      fetchBookings();
      fetchUser();
    } catch (error) {
      setWithdraw((state) => ({
        ...state,
        status: "failed",
        error: error.response.data,
      }));
    }
  };

  return (
    <Layout>
      <div className="container mx-auto">
        <div className="lg:py-5 lg:px-0 py-4 px-4">
          <h1 className="font-bold text-lg mb-4">My Bookings</h1>

          <div className="mb-6 border-b-2">
            <div className="flex">
              <Link
                onClick={() => setTab(0)}
                className={clsx(
                  "inline-flex px-4 py-3 hover:border-orange-600 transition duration-200 border-b-2",
                  tab === 0
                    ? "border-orange-600 font-semibold text-orange-600"
                    : "text-gray-500 border-transparent"
                )}
              >
                <svg
                  className="w-6 h-6 mr-1"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  ></path>
                </svg>
                <span className="lg:block hidden">
                  Active / Upcoming Bookings
                </span>
                <span className="lg:hidden block">Active</span>
              </Link>
              <Link
                onClick={() => setTab(1)}
                className={clsx(
                  "inline-flex px-4 py-3 hover:border-orange-600 transition duration-200 border-b-2",
                  tab === 1
                    ? "border-orange-600 font-semibold text-orange-600"
                    : "text-gray-500 border-transparent"
                )}
              >
                <svg
                  className="w-6 h-6 mr-1"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                  ></path>
                </svg>

                <span className="lg:block hidden">Past Bookings</span>
                <span className="lg:hidden block">Past</span>
              </Link>
              <Link
                onClick={() => setTab(2)}
                className={clsx(
                  "inline-flex px-4 py-3 hover:border-orange-600 transition duration-200 border-b-2",
                  tab === 2
                    ? "border-orange-600 font-semibold text-orange-600"
                    : "text-gray-500 border-transparent"
                )}
              >
                <svg
                  className="w-6 h-6 mr-1"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
                  ></path>
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                </svg>
                Settings
              </Link>
            </div>
          </div>

          {tab === 0 && (
            <div>
              {bookings.status === "succeeded" &&
                bookings?.data?.data.length === 0 && (
                  <div className="flex flex-col items-center justify-content space-y-5">
                    <svg
                      className="w-20 h-20 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                      ></path>
                    </svg>
                    <h3 className="font-bold text-lg text-center">
                      No active / upcoming booking session available
                    </h3>
                    <p className="text-gray-500">
                      Please see{" "}
                      <Link to="/" className="text-orange-500 hover:underline">
                        Rooms / Spaces
                      </Link>{" "}
                      to start booking.
                    </p>
                  </div>
                )}

              {bookings.status === "succeeded" &&
                bookings?.data?.data.length > 0 && (
                  <div className="w-full max-w-3xl mx-auto space-y-8">
                    {bookings.data?.data?.map((booking, i) => (
                      <div className="shadow-lg">
                        <div className="flex items-center justify-between bg-orange-100 px-4 py-3">
                          <h3 className="font-semibold">
                            {booking.date} ({booking.dow})
                          </h3>
                          <h3 className="font-semibold">{booking.session}</h3>
                        </div>
                        <div className="flex space-x-4 px-4 py-4">
                          <img
                            src={booking.space.thumbnail}
                            className="w-20 h-20 rounded-full object-cover"
                            alt=""
                          />
                          <div className="flex-1">
                            <p className="font-semibold">
                              [{booking.space.floor.name}] {booking.space.name}
                            </p>
                            <p className="text-gray-500 mb-3">
                              Seat/Room: {booking.room.name}
                            </p>
                            {booking.status.value === "reserved" && (
                              <div className="flex items-center">
                                <span className="bg-green-500 text-white rounded-lg px-2 py-1 text-xs">
                                  {booking.status.desc}
                                </span>
                                {booking.require_checkin_now && (
                                  <span className="inline-flex items-center text-xs text-red-600">
                                    <svg
                                      className="w-5 h-5 ml-1"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                      aria-hidden="true"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                                      ></path>
                                    </svg>
                                    Check-in required now
                                  </span>
                                )}
                                {booking.type === "group" && (
                                  <button
                                      className="text-blue-600 px-2 py-1 text-xs hover:underline"
                                      onClick={() =>
                                        onViewGroupMembers(booking)
                                      }
                                    >
                                      View Members
                                    </button>
                                )}
                              </div>
                            )}
                            {booking.status.value === "checked-in" && (
                              <span className="bg-red-500 text-white rounded-lg px-2 py-1 text-xs">
                                {booking.status.desc}
                              </span>
                            )}
                            {booking.status.value === "blocked" && (
                              <span className="bg-black text-white rounded-lg px-2 py-1 text-xs">
                                {booking.status.desc}
                              </span>
                            )}
                          </div>
                          <div>
                            {booking.is_owner && (
                              <div className="flex flex-col items-end">
                                <div>
                                  <button
                                    className="text-red-600 border rounded border-red-600 text-sm px-2 py-1 hover:bg-red-600 hover:text-white transition duration-150"
                                    onClick={() => onCancel(booking)}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          )}

          {tab === 1 && (
            <div>
              {bookings.status === "succeeded" &&
                bookings?.data?.data.length === 0 && (
                  <div className="flex flex-col items-center justify-content space-y-5">
                    <svg
                      className="w-20 h-20 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                      ></path>
                    </svg>
                    <h3 className="font-bold text-lg text-center">
                      No data available
                    </h3>
                  </div>
                )}
              {bookings.status === "succeeded" &&
                bookings?.data?.data.length > 0 && (
                  <div>
                    <div className="w-full max-w-3xl mx-auto space-y-8">
                      {bookings.data?.data?.map((booking, i) => (
                        <div className="shadow-lg">
                          <div className="flex items-center justify-between bg-gray-200 px-4 py-3">
                            <h3 className="font-semibold">
                              {booking.date} ({booking.dow})
                            </h3>
                            <h3 className="font-semibold">{booking.session}</h3>
                          </div>
                          <div className="flex space-x-4 px-4 py-4">
                            <img
                              src={booking.space.thumbnail}
                              className="w-20 h-20 rounded-full object-cover"
                              alt=""
                            />
                            <div className="flex-1">
                              <p className="font-semibold">
                                [{booking.space.floor.name}]{" "}
                                {booking.space.name}
                              </p>
                              <p className="text-gray-500">
                                Seat/Room: {booking.room.name}
                              </p>
                              <p className="text-gray-500">
                                Status: {booking.status.desc}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          )}

          {tab === 2 && <Settings />}
        </div>
      </div>

      <Transition appear show={showCancel} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => cancel.status !== "pending" && setShowCancel(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/30" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="absolute top-0 right-0 pt-4 pr-4">
                    <button
                      className="p-2 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-500"
                      onClick={() =>
                        cancel.status !== "pending" && setShowCancel(false)
                      }
                    >
                      <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  <Dialog.Description>
                    <svg
                      className="mx-auto w-14 h-14 text-gray-400 mb-4"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                      ></path>
                    </svg>
                    <h3 className="mb-5 text-lg font-normal text-gray-500">
                      Are you sure you want to cancel this booking?
                    </h3>
                    <div className="flex justify-center gap-4">
                      <button
                        disabled={cancel.status === "pending"}
                        className={clsx(
                          "bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg",
                          cancel.status === "pending"
                            ? "opacity-50 pointer-events-none"
                            : ""
                        )}
                        onClick={onConfirmCancel}
                      >
                        {cancel.status === "pending" && (
                          <svg
                            aria-hidden="true"
                            class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        )}
                        {"Yes, I'm sure"}
                      </button>
                      <button
                        className={clsx(
                          "bg-white hover:bg-gray-100 border px-4 py-2 rounded-lg",
                          cancel.status === "pending"
                            ? "opacity-50 pointer-events-none"
                            : ""
                        )}
                        disabled={cancel.status === "pending"}
                        onClick={() => setShowCancel(false)}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Description>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={showViewGroupMembers} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setShowViewGroupMembers(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/30" />
          </Transition.Child>

          {selectedBooking && selectedBooking.type === "group" && (
            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <div className="absolute top-0 right-0 pt-4 pr-4">
                      <button
                        className="p-2 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-500"
                        onClick={() => setShowViewGroupMembers(false)}
                      >
                        <svg
                          className="w-6 h-6"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-bold leading-6 text-gray-900 mb-4"
                    >
                      Group Members
                    </Dialog.Title>
                    <Dialog.Description>
                      <div className="space-y-3">
                        <div class="flex">
                          <div class="w-48">
                            <label class="inline-block font-semibold">
                              Total group members:
                            </label>
                          </div>
                          <div class="flex-1 ml-4">
                            {selectedBooking.users.length}
                          </div>
                        </div>
                        <div class="flex">
                          <div class="w-48">
                            <label class="inline-block font-semibold">
                              Group members:
                            </label>
                          </div>
                          <div class="flex-1 ml-4">
                            <ul className="list-disc ml-5">
                              {selectedBooking.users.map((user, i) => (
                                <li key={i}>{user}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        {!selectedBooking.is_owner ? (
                          <div className="space-y-2">
                            <p className="text-gray-500">
                              To withdraw from the booking, click Withdraw
                              button below.
                            </p>
                            <p className="text-gray-500">
                              After you withdraw, the booking will be cancelled
                              and released to other users.
                            </p>
                          </div>
                        ) : (
                          <div className="space-y-2">
                            <p className="text-gray-500">
                              Any member in the booking who withdraws from the
                              booking will have the booking cancelled and
                              released to other users.
                            </p>
                          </div>
                        )}
                      </div>
                    </Dialog.Description>

                    {selectedBooking && !selectedBooking.is_owner && (
                      <div className="flex justify-end space-x-2 mt-4">
                        <button
                          type="button"
                          className={clsx(
                            "inline-flex justify-center rounded-md bg-white px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-auto",
                            withdraw.status === "pending"
                              ? "opacity-50 pointer-events-none"
                              : ""
                          )}
                          disabled={withdraw.status === "pending"}
                          onClick={() => setShowViewGroupMembers(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className={clsx(
                            "inline-flex items-center justify-center rounded-md bg-red-600 px-3 py-2 text-white shadow-sm hover:bg-red-700",
                            withdraw.status === "pending"
                              ? "opacity-50 pointer-events-none"
                              : ""
                          )}
                          disabled={withdraw.status === "pending"}
                          onClick={onConfirmWithdraw}
                        >
                          {withdraw.status === "pending" && (
                            <svg
                              aria-hidden="true"
                              class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          )}
                          Withdraw
                        </button>
                      </div>
                    )}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          )}
        </Dialog>
      </Transition>
    </Layout>
  );
}
